module.exports = __webpack_public_path__ + "assets/keypad-sounds/beep12-e021bee23e90594dc4f20f29aea96f2a.wav";